module.exports = __webpack_public_path__ + "img/Schroepfen_Outline.2454f32.svg";